import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/doctocat/doctocat/theme/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Use the `}<inlineCode parentName="p">{`Note`}</inlineCode>{` component to call out information in documentation pages.`}</p>
    <h2>{`Usage`}</h2>
    <p><inlineCode parentName="p">{`Note`}</inlineCode>{` is a `}<a parentName="p" {...{
        "href": "https://mdxjs.com/blog/shortcodes"
      }}>{`shortcode`}</a>{`, meaning it's globally available in all `}<inlineCode parentName="p">{`.md`}</inlineCode>{` and `}<inlineCode parentName="p">{`.mdx`}</inlineCode>{` files. So you can use the `}<inlineCode parentName="p">{`Note`}</inlineCode>{` component in any `}<inlineCode parentName="p">{`.md`}</inlineCode>{` or `}<inlineCode parentName="p">{`.mdx`}</inlineCode>{` file without importing it.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Note>Your note goes here</Note>
`}</code></pre>
    <p>{`To write markdown syntax inside of a `}<inlineCode parentName="p">{`Note`}</inlineCode>{`, make sure to add extra newlines to separate the content from the opening and
closing tags:`}</p>
    <pre><code parentName="pre" {...{}}>{`blah blah blah

<Note>

Your _note_ goes **here**.

</Note>

blah blah blah
`}</code></pre>
    <h2>{`Variants`}</h2>
    <h3>{`Info (default)`}</h3>
    <p>{`Use the `}<inlineCode parentName="p">{`info`}</inlineCode>{` variant to call out neutral information.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Note>Your note goes here</Note>
`}</code></pre>
    <h3>{`Warning`}</h3>
    <p>{`Use the `}<inlineCode parentName="p">{`warning`}</inlineCode>{` variant to indicate that extra care should be taken.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Note variant="warning">Don't forget to give your images alt text.</Note>
`}</code></pre>
    <h3>{`Danger`}</h3>
    <p>{`Use the `}<inlineCode parentName="p">{`danger`}</inlineCode>{` variant to indicate that something bad could happen if the reader ignores the note.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Note variant="danger">Don't cut the red wire!</Note>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      